import React, { useState, useRef, useEffect } from 'react';
import Search, { createFilter } from '../../../../../Search';
import FoodSection from './FoodSection';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    //IconButton,
    Button,
    Typography,
    Box,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
//import CloseIcon from '@mui/icons-material/Close';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import AddOrEditOrderDetails from '../../../../../AiTrainingData/Components/Library/AddOrEditOrderDetails';
import PropTypes from 'prop-types';

const searchInputStyle = {
    padding: '7px',
    width: '100%',
    maxWidth: '500px',
    marginRight: '5px',
};

const MenuDialog = ({
    open,
    setOpenMenuDialog,
    setOpenFood,
    menu,
    setOpenFoodDialog,
    setOpenCustomFoodDialog,
    // in case of CallRecordingAndTrainingData,
    // we need to display the order details in the popup
    callRecAndTrainingDataToDisplay,
    removeItemFromOrder,
    rowId,
    updateTranscriptionTextForRow,
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredMenu, setFilteredMenu] = useState(menu);
    const theme = useTheme();
    useEffect(() => {
        let tempMenu = menu;
        if (searchTerm && searchTerm.trim().length > 0 && menu) {
            const filtersFoods = menu
                .flatMap((sec) => sec.foods)
                .filter(
                    createFilter(searchTerm, ['name', 'desc'], {
                        fuzzy: false,
                    })
                );
            tempMenu = [
                {
                    id: 'searchResult' + searchTerm,
                    name: 'Results for ' + searchTerm,
                    foods: filtersFoods,
                },
            ];
        }
        setFilteredMenu(tempMenu);
    }, [menu, searchTerm]);
    const searchRef = useRef(null);
    const searchInputRef = useRef();
    const showCountInResults =
        searchTerm && searchTerm.length > 0 ? { showCount: true } : {};

    const close = () => {
        setOpenMenuDialog(false);
    };

    const addCustomItem = () => {
        setOpenCustomFoodDialog(true);
    };

    return (
        <Dialog open={open} fullScreen>
            <DialogTitle sx={{ m: 0, p: 2 }}>
                {close ? (
                    <Button
                        size="small"
                        variant="outlined"
                        //style={{ marginRight: 8 }}
                        sx={{
                            position: 'absolute',
                            right: 25,
                            top: 10,
                        }}
                        onClick={close}
                    >
                        Back
                    </Button>
                ) : null}
            </DialogTitle>

            <DialogContent>
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        gap: '10px',
                        marginTop: '10px',
                    }}
                >
                    <Box
                        ref={searchInputRef}
                        sx={{
                            width: { xs: '90%', sm: '30%' },
                            boxSizing: 'border-box',
                            zIndex: 2,
                            backgroundColor: 'white',
                            paddingTop: '10px',
                            paddingBottom: '10px',
                        }}
                    >
                        <Search
                            type={'input'}
                            ref={searchRef}
                            style={searchInputStyle}
                            value={searchTerm}
                            onChange={(term) => {
                                setSearchTerm(term);
                            }}
                        ></Search>
                    </Box>

                    <Button
                        component="label"
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: 1,
                            gap: 1,
                            px: 2,
                            py: 1,
                            whiteSpace: 'nowrap',
                            [theme.breakpoints.down('sm')]: {
                                minWidth: 'auto',
                                px: 1,
                            },
                        }}
                        onClick={addCustomItem}
                    >
                        <AddCircleSharpIcon
                            color="primary"
                            sx={{ fontSize: 20 }}
                        />
                        <Typography variant="body2">Add Custom Item</Typography>
                    </Button>

                    {/* in case of CallRecordingAndTrainingData, 
                    we need to display the order details in the popup */}
                    {callRecAndTrainingDataToDisplay && (
                        <AddOrEditOrderDetails
                            callRecAndTrainingDataToDisplay={
                                callRecAndTrainingDataToDisplay
                            }
                            removeItemFromOrder={removeItemFromOrder}
                            rowId={rowId}
                            updateTranscriptionTextForRow={
                                updateTranscriptionTextForRow
                            }
                        />
                    )}
                </div>

                <div style={{ marginTop: '50px' }}>
                    {filteredMenu &&
                        filteredMenu.map((section, sidx) =>
                            section && section.foods ? (
                                <FoodSection
                                    key={section.id}
                                    sidx={sidx}
                                    {...section}
                                    {...showCountInResults}
                                    setOpenFood={setOpenFood}
                                    setOpenFoodDialog={setOpenFoodDialog}
                                />
                            ) : (
                                <div key={sidx} />
                            )
                        )}
                </div>

                <Button
                    component="label"
                    sx={{
                        mt: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: 1,
                        [theme.breakpoints.down('xs')]: {
                            maxWidth: '20%',
                        },
                        [theme.breakpoints.up('md')]: {
                            maxWidth: '9%',
                        },
                    }}
                    onClick={addCustomItem}
                >
                    <AddCircleSharpIcon color="primary" sx={{ fontSize: 20 }} />
                    <Typography
                        align="center"
                        variant="body2"
                        sx={{ m: 'auto' }}
                    >
                        Add Custom Item
                    </Typography>
                </Button>
            </DialogContent>
        </Dialog>
    );
};

MenuDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpenMenuDialog: PropTypes.func.isRequired,
    setOpenFood: PropTypes.func.isRequired,
    menu: PropTypes.array,
    setOpenFoodDialog: PropTypes.func.isRequired,
    setOpenCustomFoodDialog: PropTypes.func.isRequired,
    callRecAndTrainingDataToDisplay: PropTypes.object,
};

export default MenuDialog;
